import { Button, Css } from "@homebound/beam";
import { ObjectConfig, ObjectState, required, useFormState } from "@homebound/form-state";
import { Observer } from "mobx-react";
import { ScheduleFlagDetailFragment } from "src/fragments/circularFragments.generated";
import { InputMaybe, SaveScheduleFlagInput } from "src/generated/graphqlTypes";
import { ScheduleFlagReasonDetailFragment } from "src/routes/projects/schedule-v2/detail-pane/scheduleFlags/ScheduleFlags.generated";
import { ScheduleFlagForm } from "./ScheduleFlagForm";

type ScheduleFlagProps = {
  scheduleFlag: ScheduleFlagDetailFragment | null;
  reasons: ScheduleFlagReasonDetailFragment[];
  onClose: () => void;
  onSave: (os: ObjectState<ScheduleFlagFormConfig>) => void | Promise<void>;
  hideText?: boolean;
};
export function ScheduleFlag({ scheduleFlag, reasons, onClose, onSave, hideText }: ScheduleFlagProps) {
  const formState = useFormState({
    config: formConfig,
    init: { input: scheduleFlag, map: mapToFormState, ifUndefined: { durationInDays: 0, category: null } },
  });

  return (
    <Observer>
      {() => (
        <div css={Css.df.fdc.gap1.mb1.mt1.$}>
          {hideText !== true && (
            <>
              <span css={Css.mdSb.$}>{scheduleFlag ? "Edit" : "Add"} a Flag</span>
              <span css={Css.xs2.$}>
                Only zero day delays can be created without schedule changes. For delays longer than 0 days, update the
                task dates above.
              </span>
            </>
          )}
          <ScheduleFlagForm formState={formState} reasons={reasons} onClose={onClose} />
          <div css={Css.df.fdrr.$}>
            <Button
              label={`Confirm ${scheduleFlag ? "Edit" : "Adding"} Flag`}
              disabled={!formState.canSave()}
              variant="tertiary"
              onClick={() => onSave(formState)}
            />
          </div>
        </div>
      )}
    </Observer>
  );
}

export type ScheduleFlagFormConfig = Partial<SaveScheduleFlagInput> & { category: InputMaybe<string> };

export const formConfig: ObjectConfig<ScheduleFlagFormConfig> = {
  id: { type: "value" },
  reasonId: { type: "value", rules: [required] },
  durationInDays: { type: "value", rules: [required] },
  description: { type: "value" },
  scheduleTaskId: { type: "value" },
  category: { type: "value" },
};

export function mapToFormState(flag: ScheduleFlagDetailFragment): ScheduleFlagFormConfig {
  const { id, durationInDays, description, reason } = flag;
  return { id, reasonId: reason?.id, durationInDays, description, category: null };
}
